// extracted by mini-css-extract-plugin
export default {"Wrapper":"InterventionsActions_Wrapper__WDAPx"};